module.exports = __webpack_public_path__ + "static-portal/img/news12-3.ed14553.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news12-3.jpg
// module id = 9rx/
// module chunks = 4